<template>
  <v-card class="pa-2 mt-3" outlined flat>
    <v-form>
      <v-container>
        <v-row>
          <v-col cols="12" md="3">
            <v-text-field v-model="items.provider" label="Provider" :outlined="outlined"></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field v-model="items.individualName" label="Individual Served Name"
              :outlined="outlined"></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field v-model="items.year" label="year" :outlined="outlined"></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field v-model="items.caseNo" label="Case No" :outlined="outlined"></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" class="white--text text-uppercase text-center text-caption"
            style="background-color: #2b3990">Reporting Period
          </v-col>
          <v-col>
            <v-row>
              <v-col cols="12" sm="6">
                <v-checkbox v-model="items.chkJFM" label="January, February, March (Due by May 5th)"
                  value="John"></v-checkbox>
                <v-checkbox v-model="items.chkAMJ" label="April, May, June (Due by August 5th)"
                  value="Jacob"></v-checkbox>
              </v-col>
              <v-col cols="12" sm="6">
                <v-checkbox v-model="items.chkJAS" label="July, August, September (Due by Nov. 5th)"
                  value="Jacob"></v-checkbox>
                <v-checkbox v-model="items.chkOND" label="October, November, December (Due by Feb. 5th)"
                  value="Jacob"></v-checkbox>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" class="white--text text-uppercase text-center text-caption"
            style="background-color: #2b3990">Describe specific progress toward PCP Support Plans in this
            reporting period.
          </v-col>
          <v-col>
            <v-row v-for="(item, i) in items.scopeObjectives" :key="i">
              <v-col>
                <v-sheet elevation="1" class="pa-5">
                  <v-btn v-if="items.scopeObjectives.length > 1" color="red" dark right x-small max-height="25"
                    max-width="25" class="fab--btn delete" fab @click="removeScopeObjective">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                  <v-row>
                    <v-col cols="12" sm="6">
                      <v-text-field v-model="item.scope" label="Scoped" :outlined="outlined"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-text-field v-model="item.objective" label="Objective" :outlined="outlined"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12">
                      <v-text-field v-model="item.summary"
                        label="Describe progress toward scope/objectives including summary of data collected: (in box below)"
                        :outlined="outlined"></v-text-field>
                    </v-col>
                  </v-row>
                </v-sheet>
              </v-col>
            </v-row>
            <div v-if="items.scopeObjectives.length < 5" class="d-flex mt-3 mb-3 d-flex justify-end">
              <v-btn color="primary" dark right max-height="25" max-width="25" class="" @click="addScopeObjective">
                add
              </v-btn>
            </div>
          </v-col>

          <v-col cols="12" sm="12">
            <v-text-field v-model="items.describeSupportsSummary"
              label="Describe protective oversight and supervision supports: (in box below)"
              :outlined="outlined"></v-text-field>
          </v-col>

          <v-col cols="12" sm="12">
            <p class="font-weight-bold">
              Describe your contact with school or work site: (in box below)
            </p>
            <div class="d-flex align-center">
              <span class="font-weight-bold mr-2">Was school or work site notified of medication changes:</span>
              <div class="d-flex">
                <v-radio-group v-model="items.rbgNotified" row>
                  <v-radio label="Yes" value="true"></v-radio>
                  <v-radio label="No" value="false"></v-radio>
                  <v-radio label="N/A" value="none"></v-radio>
                </v-radio-group>
              </div>
            </div>
            <v-text-field v-model="items.notifiedSummary" label="Describe your contact with school or work site"
              :outlined="outlined"></v-text-field>

            <v-text-field v-model="items.describeIndividualSummary"
              label="Describe individual’s contact with family and friends" :outlined="outlined"></v-text-field>

            <v-text-field v-model="items.activitiesSummary" label="Summarize any recreational activities"
              :outlined="outlined"></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" class="white--text text-uppercase text-center text-caption"
            style="background-color: #2b3990">Describe Medical Treatment Provided During the Quarter
          </v-col>

          <v-col cols="12" sm="12">
            <div class="d-flex align-center">
              <span class="font-weight-bold mr-2">Physicians Visits:</span>
              <div class="d-flex">
                <v-radio-group v-model="items.rbgPhysicianVisit" row>
                  <v-radio label="No Visits" value="false"></v-radio>
                  <v-radio label="Yes" value="true"></v-radio>
                </v-radio-group>
              </div>
            </div>
            <p class="font-italic text-body-2">
              (Complete the boxes in the table below. Include consults and lab
              work i.e.: dental, vision, neurology, podiatry, psychiatry…etc.)
            </p>
            <div class="ma-1"></div>
          </v-col>

          <v-col cols="12">
            <v-row v-for="(item, i) in items.physicians" :key="i">
              <v-col>
                <v-sheet elevation="1" class="pa-5">
                  <v-btn v-if="items.physicians.length > 1" color="red" dark right x-small max-height="25"
                    max-width="25" class="fab--btn delete" fab @click="removePhysician">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                  <v-row>
                    <v-col cols="12" sm="3">
                      <v-text-field v-model="item.physician" label="Physician" :outlined="outlined"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3">
                      <v-text-field v-model="item.specialty" label="Specialty" :outlined="outlined"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3">
                      <v-text-field v-model="item.dateSeen" label="Date Seen" :outlined="outlined"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3">
                      <v-text-field v-model="item.recommendation" label="Reason seen/Recomendations"
                        :outlined="outlined"></v-text-field>
                    </v-col>
                  </v-row>
                </v-sheet>
              </v-col>
            </v-row>
            <div v-if="items.physicians.length < 2" class="d-flex mt-3 mb-3 d-flex justify-end">
              <v-btn color="primary" dark right max-height="25" max-width="25" class="" @click="addPhysician">
                add
              </v-btn>
            </div>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <p class="font-weight-bold mr-2">
              Current Medication: (as of this report date)
            </p>
          </v-col>
          <v-col cols="12">
            <v-row v-for="(item, i) in items.currentMedication" :key="i">
              <v-col>
                <v-sheet elevation="1" class="pa-5">
                  <v-btn v-if="items.currentMedication.length > 1" color="red" dark right x-small max-height="25"
                    max-width="25" class="fab--btn delete" fab @click="removeCurrentMedication">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                  <v-row>
                    <v-col cols="12" sm="4">
                      <v-text-field v-model="item.medication" label="Medication" :outlined="outlined"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4">
                      <v-text-field v-model="item.dosage" label="Dosage" :outlined="outlined"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4">
                      <v-text-field v-model="item.physician" label="Physician" :outlined="outlined"></v-text-field>
                    </v-col>
                  </v-row>
                </v-sheet>
              </v-col>
            </v-row>
            <div v-if="items.currentMedication.length < 3" class="d-flex mt-3 mb-3 d-flex justify-end">
              <v-btn color="primary" dark right max-height="25" max-width="25" class="" @click="addCurrentMedication">
                add
              </v-btn>
            </div>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <div class="d-flex align-center">
              <span class="font-weight-bold mr-2">Changes in Medications:</span>
              <div class="d-flex">
                <v-radio-group v-model="items.rbgMedicationChange" row>
                  <v-radio label="No Change" value="false"></v-radio>
                  <v-radio label="Yes (if yes, complete the boxes in the table below)" value="true"></v-radio>
                </v-radio-group>
              </div>
            </div>
          </v-col>
          <v-col cols="12">
            <v-row v-for="(item, i) in items.medicationChange" :key="i">
              <v-col>
                <v-sheet elevation="1" class="pa-5">
                  <v-btn v-if="items.medicationChange.length > 1" color="red" dark right x-small max-height="25"
                    max-width="25" class="fab--btn delete" fab @click="removeMedicationChange">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                  <v-row>
                    <v-col cols="12" sm="3">
                      <v-text-field v-model="item.medicationChange" label="Medication"
                        :outlined="outlined"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3">
                      <v-text-field v-model="item.changeDosage" label="Dosage" :outlined="outlined"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3">
                      <v-text-field v-model="item.changeReason" label="Reason for change"
                        :outlined="outlined"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3">
                      <v-text-field v-model="item.changePhysician" label="Physician"
                        :outlined="outlined"></v-text-field>
                    </v-col>
                  </v-row>
                </v-sheet>
              </v-col>
            </v-row>
            <div v-if="items.medicationChange.length < 2" class="d-flex mt-3 mb-3 d-flex justify-end">
              <v-btn color="primary" dark right max-height="25" max-width="25" class="" @click="addMedicationChange">
                add
              </v-btn>
            </div>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <div class="d-flex align-center">
              <span class="font-weight-bold mr-2">Medication side effects discussed:</span>
              <div class="d-flex">
                <v-radio-group v-model="items.rbgSideEffect" row>
                  <v-radio label="N/A" value="none"></v-radio>
                  <v-radio label="Yes" value="true"></v-radio>
                  <v-radio label="No, reason why" value="false"></v-radio>
                </v-radio-group>
              </div>
            </div>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <div class="d-flex align-center">
              <span class="font-weight-bold mr-2">Hospitalizations:</span>
              <div class="d-flex">
                <v-radio-group v-model="items.rbgHospitalization" row>
                  <v-radio label="No hospitalizations" value="false"></v-radio>
                  <v-radio label="Yes (if yes complete box)" value="true"></v-radio>
                </v-radio-group>
              </div>
            </div>
          </v-col>

          <v-col cols="12" md="3">
            <v-text-field v-model="items.hospitalizationDate" label="Date" :outlined="outlined"></v-text-field>
          </v-col>

          <v-col cols="12" md="9">
            <v-text-field v-model="items.hospitalizationReason" label="Reason for hospitalization:"
              :outlined="outlined"></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <p class="font-weight-bold mr-2">
              Resources/Benefits: (Complete ONLY if you are the representative
              payee for the individual)
            </p>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field v-model="items.currentBalance" label="Current checking/saving balance:"
              :outlined="outlined"></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field v-model="items.trustFund" label="Trust Fund Reconciled on date(s):"
              :outlined="outlined"></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field v-model="items.ssRepresentative"
              label="SS Representative Payee/Disability Report(s) Completed:" :outlined="outlined"></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field v-model="items.redeterminationDate"
              label="Re-determination for Medicaid was completed on this date:" :outlined="outlined"></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field v-model="items.benefitsReason" label="Reason benefits have stopped, disrupted, or terminated:"
              :outlined="outlined"></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <p class="font-weight-bold mr-2">
              Safety/Emergencies Drill and Living Environment/Quality Assurance:
            </p>
            <v-col cols="12" sm="4">
              <p class="font-weight-thin mr-2">
                Safety/Emergency Drill was conducted on these dates:
              </p>
              <div v-for="(item, i) in items.safetyDates" :key="i">
                <v-btn v-if="items.safetyDates.length > 1" color="red" dark right x-small max-height="25" max-width="25"
                  class="fab--btn delete custome" fab @click="removeSafetyDate(i)">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-text-field v-model="item.safetyDrillDate" label="Month" :outlined="outlined"></v-text-field>
              </div>
              <div v-if="items.safetyDates.length < 3">
                <v-btn color="primary" dark right max-height="25" class="" @click="addSafetyDate">
                  add date
                </v-btn>
              </div>
            </v-col>

            <v-col cols="12" sm="4" class="mt-5">
              <p class="font-weight-thin mr-2">
                Living Environment/QA was conducted on these dates:
              </p>

              <div v-for="(item, i) in items.livingDates" :key="i">
                <v-btn v-if="items.livingDates.length > 1" color="red" dark right x-small max-height="25" max-width="25"
                  class="fab--btn delete custome" fab @click="removeLivingDate(i)">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-text-field v-model="item.livingEnvironmentDate" label="Month" :outlined="outlined"></v-text-field>
              </div>
              <div v-if="items.livingDates.length < 3">
                <v-btn color="primary" dark right max-height="25" class="" @click="addLivingDate">
                  add date
                </v-btn>
              </div>
            </v-col>
          </v-col>

          <v-col cols="12">
            <v-text-field v-model="items.additionalComments" label="Additional comments"
              :outlined="outlined"></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <p class="font-weight-bold">Report Completed By:</p>
            <v-row>
              <v-col cols="12" sm="4">
                <v-text-field v-model="items.reportedByName" label="Print" :outlined="outlined"></v-text-field>
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field v-model="items.reportedBySignature" label="Signature" :outlined="outlined"></v-text-field>
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field v-model="items.reportedByDate" label="Date" :outlined="outlined"></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <p class="font-weight-bold">QIDP Review By:</p>
            <v-row>
              <v-col cols="12" sm="4">
                <v-text-field v-model="items.reviewByName" label="Print" :outlined="outlined"></v-text-field>
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field v-model="items.reviewBySignature" label="Signature" :outlined="outlined"></v-text-field>
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field v-model="items.reviewByDate" label="Date" :outlined="outlined"></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </v-card>
</template>
<script>
/*eslint-disable */
export default {
  props: {
    items: Object
  },
  data() {
    return {
      outlined: true,
      // items: {
      //   scopeObjectives: [{}],
      //   physicians: [{}],
      //   currentMedication: [{}],
      //   medicationChange: [{}],
      //   safetyDates: [{}],
      //   livingDates: [[]]
      // },
    };
  },
  methods: {

    getItems(){
      return this.items
    },

    getData() {
      return this.flattenArrays(this.items);
    },

    addMonth() {
      this.items.months.push({});
    },

    removeMonth(i) {
      this.items.months.splice(i, 1);
    },

    addScopeObjective() {
      this.items.scopeObjectives.push({});
    },

    removeScopeObjective(i) {
      this.items.scopeObjectives.splice(i, 1);
    },

    addCurrentMedication() {
      this.items.currentMedication.push({});
    },

    removeCurrentMedication(i) {
      this.items.currentMedication.splice(i, 1);
    },

    addMedicationChange() {
      this.items.medicationChange.push({});
    },

    removeMedicationChange(i) {
      this.items.medicationChange.splice(i, 1);
    },

    addPhysician() {
      this.items.physicians.push({});
    },

    removePhysician(i) {
      this.items.physicians.splice(i, 1);
    },

    addSafetyDate() {
      this.items.safetyDates.push({});
    },

    removeSafetyDate(i) {
      this.items.safetyDates.splice(i, 1);
    },

    addLivingDate() {
      this.items.livingDates.push({});
    },

    removeLivingDate(i) {
      this.items.livingDates.splice(i, 1);
    },

    flattenArrays(data) {
      const flattened = {};

      Object.entries(data).forEach(([key, value]) => {
        if (!Array.isArray(value)) {
          flattened[key] = value;
        } else {
          value.forEach((item, index) => {
            Object.entries(item).forEach(([innerKey, innerValue]) => {
              flattened[`${innerKey}${index + 1}`] = innerValue;
            });
          });
        }
      });

      return flattened;
    },
  },
};
</script>

<style scoped>
h1 {
  font-size: 1.5rem;
  font-weight: 400;
}

.fab--btn {
  display: "absolute";
  bottom: 10px;
}

.fab--btn.delete {
  right: calc(-100% + 20px);
}

.fab--btn.delete.custome {
  right: calc(-100% + -10px);
  top: 40px;
}
</style>
